const keyBy = require('lodash/keyBy')

const WAREHOUSE_DEFINITIONS = {
  'PSM': {
    'DC-301 :: MDS Abuja': {
      warehouseCode: 'DC-301 :: MDS Abuja',
      zone: 'zone:north-central',
      name: 'MDS Abuja',
      _id: 'zone:north-central:name:mds-abuja',
      suppliesColdChain: true,
      lookupId: 'mds-abuja'
    },
    'NDC-201 :: Abuja Premier Medical Warehouse': {
      warehouseCode: 'NDC-201 :: Abuja Premier Medical Warehouse',
      zone: 'zone:north-central',
      name: 'Abuja Premier Medical Warehouse',
      _id: 'zone:north-central:name:abuja',
      suppliesColdChain: true,
      lookupId: 'abuja'
    },
    'DC-303 :: Axios Warehouse Awka': {
      warehouseCode: 'DC-303 :: Axios Warehouse Awka',
      zone: 'zone:south-south',
      name: 'Axios Warehouse Awka',
      _id: 'zone:south-south:name:awka',
      lookupId: 'awka'
    },
    'DC-309 :: MDS Warehouse Calabar': {
      warehouseCode: 'DC-309 :: MDS Warehouse Calabar',
      zone: 'zone:south-south',
      name: 'MDS Warehouse Calabar',
      _id: 'zone:south-south:name:calabar',
      lookupId: 'calabar'
    },
    'DC-305 :: Axios Warehouse Gombe': {
      warehouseCode: 'DC-305 :: Axios Warehouse Gombe',
      zone: 'zone:north-east',
      name: 'Axios Warehouse Gombe',
      _id: 'zone:north-east:name:gombe',
      lookupId: 'gombe'
    },
    'DC-306 :: Axios Warehouse Sokoto': {
      warehouseCode: 'DC-306 :: Axios Warehouse Sokoto',
      zone: 'zone:north-west',
      name: 'Axios Warehouse Sokoto',
      _id: 'zone:north-west:name:sokoto',
      lookupId: 'sokoto'
    },
    'NDC-202 :: Lagos Premier Medical Warehouse': {
      warehouseCode: 'NDC-202 :: Lagos Premier Medical Warehouse',
      zone: 'zone:south-west',
      name: 'Lagos Premier Medical Warehouse',
      _id: 'zone:south-west:name:lagos',
      suppliesColdChain: true,
      lookupId: 'lagos'
    },
    'SDC/601/BAU': {
      warehouseCode: 'SDC/601/BAU',
      zone: 'zone:north-east',
      name: 'Bauchi State Central Medical Store',
      _id: 'zone:north-east:name:bauchi',
      lookupId: 'bauchi'
    },
    'SDC/608/SKT': {
      warehouseCode: 'SDC/608/SKT',
      zone: 'zone:north-west',
      name: 'Sokoto State Central Medical Store',
      _id: 'zone:north-west:name:sokoto-state',
      lookupId: 'sokoto'
    },
    'SDC/609/ZMF': {
      warehouseCode: 'SDC/609/ZMF',
      zone: 'zone:north-west',
      name: 'Zamfara State Central Medical Store',
      _id: 'zone:north-west:name:zamfara-state',
      lookupId: 'zamfara'
    },
    'SDC/611/NSW': {
      warehouseCode: 'SDC/611/NSW',
      zone: 'zone:north-central',
      name: 'Nasarawa State Central Medical Store',
      _id: 'zone:north-central:name:nasarawa-state',
      lookupId: 'nasarawa'
    },
    'SDC/626/BEN': {
      warehouseCode: 'SDC/626/BEN',
      zone: 'zone:north-central',
      name: 'Benue State Central Medical Store',
      _id: 'zone:north-central:name:benue-state',
      lookupId: 'benue'
    },
    'SDC/605/GMB': {
      warehouseCode: 'SDC/605/GMB',
      zone: 'zone:north-east',
      name: 'Gombe State Central Medical Store',
      _id: 'zone:north-east:name:gombe-state-central-medical-store',
      lookupId: 'gombe-state'
    },
    'SDC/604/YBE': {
      warehouseCode: 'SDC/604/YBE',
      zone: 'zone:north-east',
      name: 'Yobe State Central Medical Store',
      _id: 'zone:north-east:name:yobe-state-central-medical-store',
      lookupId: 'yobe'
    },
    'SDC/603/ADM': {
      warehouseCode: 'SDC/603/ADM',
      zone: 'zone:north-east',
      name: 'Adamawa State Central Medical Store',
      _id: 'zone:north-east:name:adamawa-state-central-medical-store',
      lookupId: 'adamawa'
    },
    'SDC/606/KANO': {
      warehouseCode: 'SDC/606/KANO',
      zone: 'zone:north-west',
      name: 'Kano State Central Medical Store',
      _id: 'zone:north-west:name:kano-state-central-medical-store',
      lookupId: 'kano'
    },
    'SDC/607/KDN': {
      warehouseCode: 'SDC/607/KDN',
      zone: 'zone:north-west',
      name: 'Kaduna State Central Medical Store',
      _id: 'zone:north-west:name:kaduna-state-central-medical-store',
      lookupId: 'kaduna'
    }
  },
  'EPN': {
    'KE-EPN-CHAK': {
      warehouseCode: 'KE-EPN-CHAK',
      name: 'Chak Meds Warehouse Nairobi',
      _id: 'country:ke:state:nairobi:name:chak-meds-warehouse-nairobi'
    },
    'NG-EPN-JOS': {
      warehouseCode: 'NG-EPN-JOS',
      name: 'Chan Jos Warehouse',
      _id: 'zone:north-central:name:chan-jos-warehouse'
    },
    'NG-EPN-Q7H71': {
      warehouseCode: 'NG-EPN-Q7H71',
      name: 'ASE Hospital Bukuru HUB',
      _id: 'zone:north-central:name:ase-hospital-bukuru-hub'
    },
    'NG-EPN-WT7JK': {
      warehouseCode: 'NG-EPN-WT7JK',
      name: 'COCIN hospital & Rehabilitation Center, Mangu HUB',
      _id: 'zone:north-central:name:cocin-hospital-rehabilitation-center-mangu-hub'
    },
    'NG-EPN-PM5P0': {
      warehouseCode: 'NG-EPN-PM5P0',
      name: 'OLA Hospital Jos HUB',
      _id: 'zone:north-central:name:ola-hospital-jos-hub'
    },
    'NG-EPN-DV7OD': {
      warehouseCode: 'NG-EPN-DV7OD',
      name: 'Bishop Moore Memorial hospital HUB',
      _id: 'zone:north-east:name:bishop-moore-memorial-hospital-hub'
    },
    'NG-EPN-4IZ2X': {
      warehouseCode: 'NG-EPN-4IZ2X',
      name: 'COCIN Community Dev Prog Molai HUB',
      _id: 'zone:north-east:name:cocin-community-dev-prog-molai-hub'
    },
    'NG-EPN-XBEZ6': {
      warehouseCode: 'NG-EPN-XBEZ6',
      name: 'GECHAAN lifeline center HUB',
      _id: 'zone:north-east:name:gechaan-lifeline-center-hub'
    },
    'NG-EPN-H9HE2': {
      warehouseCode: 'NG-EPN-H9HE2',
      name: 'OLA Clinic Tafawa Balewa HUB',
      _id: 'zone:north-east:name:ola-clinic-tafawa-balewa-hub'
    },
    'NG-EPN-K9HE1': {
      warehouseCode: 'NG-EPN-K9HE1',
      name: 'Our Lady Queen of Peace Hospital Jalingo HUB',
      _id: 'zone:north-east:name:our-lady-queen-of-peace-hospital-jalingo-hub'
    },
    'NG-EPN-025F8': {
      warehouseCode: 'NG-EPN-025F8',
      name: 'St Luke\'s Health Center, Gombe HUB',
      _id: 'zone:north-east:name:st-lukes-health-center-gombe-hub'
    },
    'NG-EPN-D2HT1': {
      warehouseCode: 'NG-EPN-D2HT1',
      name: 'St. Peter\'s Clinic Jauro Yinu HUB',
      _id: 'zone:north-east:name:st-peters-clinic-jauro-yinu-hub'
    },
    'NG-EPN-RLLHS': {
      warehouseCode: 'NG-EPN-RLLHS',
      name: 'UMCN Hospital Jalingo HUB',
      _id: 'zone:north-east:name:umcn-hospital-jalingo-hub'
    }
  },
  'LASG': {
    'NG-LAGOS': {
      warehouseCode: 'NG-LAGOS',
      name: 'Central Medical Store Lagos',
      _id: 'zone:south-west:name:central-medical-store-lagos'
    }
  },
  'KDSG': {
    'NG-KADUNA': {
      warehouseCode: 'NG-KADUNA',
      name: 'Kaduna Warehouse',
      _id: 'zone:north-west:name:kaduna-warehouse'
    }
  },
  'KNSG': {
    'CENTRAL-DMCSA': {
      warehouseCode: 'CENTRAL-DMCSA',
      name: 'Central DMCSA Kano',
      _id: 'zone:north-west:name:central-dmcsa-kano'
    },
    'DAMBATTA-ZONAL-WAREHOUSE': {
      warehouseCode: 'DAMBATTA-ZONAL-WAREHOUSE',
      name: 'Dambatta Zonal Warehouse',
      _id: 'zone:north-west:name:dambatta-zonal-warehouse'
    },
    'GAYA-ZONAL-WAREHOUSE': {
      warehouseCode: 'GAYA-ZONAL-WAREHOUSE',
      name: 'Gaya Zonal Warehouse',
      _id: 'zone:north-west:name:gaya-zonal-warehouse'
    },
    'GWARZO-ZONAL-WAREHOUSE': {
      warehouseCode: 'GWARZO-ZONAL-WAREHOUSE',
      name: 'Gwarzo Zonal Warehouse',
      _id: 'zone:north-west:name:gwarzo-zonal-warehouse'
    },
    'RANO-ZONAL-WAREHOUSE': {
      warehouseCode: 'RANO-ZONAL-WAREHOUSE',
      name: 'Rano Zonal Warehouse',
      _id: 'zone:north-west:name:rano-zonal-warehouse'
    },
    // zone:north-west:name:kano-warehouse" ADDING THIS FOR THE TIME BEING AS KANO WAREHOUSE IS STILL IN USE FOR SOME PROGRAMS, WE CAN REMOVE THIS ONCE ALL PROGRAMS HAVE BEEN MIGRATED TO THE NEW WAREHOUSES
    'NG-KANO': {
      warehouseCode: 'NG-KANO',
      name: 'Kano Warehouse',
      _id: 'zone:north-west:name:kano-warehouse'
    }
  },
  'BNSG': {
    'NG-BORNO': {
      warehouseCode: 'NG-BORNO',
      name: 'Borno Warehouse',
      _id: 'zone:north-east:name:borno-warehouse'
    }
  },
  'GBSG': {
    'NG-GOMBE': {
      warehouseCode: 'NG-GOMBE',
      name: 'Gombe Warehouse',
      _id: 'zone:north-east:name:gombe-warehouse'
    }
  },
  'NAIROBI': {
    'NAIROBI-WAREHOUSE': {
      warehouseCode: 'NAIROBI-WAREHOUSE',
      name: 'Nairobi Central Store',
      _id: 'country:ke:state:nairobi:name:nairobi-central-store'
    }
  },
  'RMS': {
    '1071': {
      'warehouseCode': '1071',
      'name': 'RMS Burera',
      '_id': 'country:rw:zone:north:name:rms-burera'
    },
    '1084': {
      'warehouseCode': '1084',
      'name': 'RMS Gakenke',
      '_id': 'country:rw:zone:north:name:rms-gakenke'
    },
    '1073': {
      'warehouseCode': '1073',
      'name': 'RMS Gatsibo',
      '_id': 'country:rw:zone:east:name:rms-gatsibo'
    },
    '1086': {
      'warehouseCode': '1086',
      'name': 'RMS Gicumbi',
      '_id': 'country:rw:zone:north:name:rms-gicumbi'
    },
    '1075': {
      'warehouseCode': '1075',
      'name': 'RMS Gisagara',
      '_id': 'country:rw:zone:south:name:rms-gisagara'
    },
    '1098': {
      'warehouseCode': '1098',
      'name': 'RMS Huye',
      '_id': 'country:rw:zone:south:name:rms-huye'
    },
    '1083': {
      'warehouseCode': '1083',
      'name': 'RMS Kamonyi',
      '_id': 'country:rw:zone:south:name:rms-kamonyi'
    },
    '1087': {
      'warehouseCode': '1087',
      'name': 'RMS Karongi',
      '_id': 'country:rw:zone:west:name:rms-karongi'
    },
    '1096': {
      'warehouseCode': '1096',
      'name': 'RMS Kayonza',
      '_id': 'country:rw:zone:east:name:rms-kayonza'
    },
    '1000': {
      'warehouseCode': '1000',
      'name': 'RMS Kigali HQ',
      '_id': 'country:rw:zone:kigali-city:name:rms-kigali-hq'
    },
    '7000': {
      'warehouseCode': '7000',
      'name': 'RMS Kigali Regional Warehouse',
      '_id': 'country:rw:zone:kigali-city:name:rms-kigali-regional-warehouse'
    },
    '1002': {
      'warehouseCode': '1002',
      'name': 'RMS Zipline Rwanda Ltd',
      '_id': 'country:rw:zone:kigali-city:name:rms-zipline-rwanda-ltd'
    },
    '1079': {
      'warehouseCode': '1079',
      'name': 'RMS Kirehe',
      '_id': 'country:rw:zone:east:name:rms-kirehe'
    },
    '1088': {
      'warehouseCode': '1088',
      'name': 'RMS Muhanga',
      '_id': 'country:rw:zone:south:name:rms-muhanga'
    },
    '1100': {
      'warehouseCode': '1100',
      'name': 'RMS Musanze',
      '_id': 'country:rw:zone:north:name:rms-musanze'
    },
    '1076': {
      'warehouseCode': '1076',
      'name': 'RMS Ngoma',
      '_id': 'country:rw:zone:east:name:rms-ngoma'
    },
    '1085': {
      'warehouseCode': '1085',
      'name': 'RMS Ngororero',
      '_id': 'country:rw:zone:west:name:rms-ngororero'
    },
    '1097': {
      'warehouseCode': '1097',
      'name': 'RMS Nyabihu',
      '_id': 'country:rw:zone:west:name:rms-nyabihu'
    },
    '1081': {
      'warehouseCode': '1081',
      'name': 'RMS Nyagatare',
      '_id': 'country:rw:zone:east:name:rms-nyagatare'
    },
    '1080': {
      'warehouseCode': '1080',
      'name': 'RMS Nyamagabe',
      '_id': 'country:rw:zone:south:name:rms-nyamagabe'
    },
    '1094': {
      'warehouseCode': '1094',
      'name': 'RMS Nyamasheke',
      '_id': 'country:rw:zone:west:name:rms-nyamasheke'
    },
    '1089': {
      'warehouseCode': '1089',
      'name': 'RMS Nyanza',
      '_id': 'country:rw:zone:south:name:rms-nyanza'
    },
    '1074': {
      'warehouseCode': '1074',
      'name': 'RMS Nyaruguru',
      '_id': 'country:rw:zone:south:name:rms-nyaruguru'
    },
    '1091': {
      'warehouseCode': '1091',
      'name': 'RMS Rubavu',
      '_id': 'country:rw:zone:west:name:rms-rubavu'
    },
    '1072': {
      'warehouseCode': '1072',
      'name': 'RMS Ruhango',
      '_id': 'country:rw:zone:south:name:rms-ruhango'
    },
    '1082': {
      'warehouseCode': '1082',
      'name': 'RMS Rulindo',
      '_id': 'country:rw:zone:north:name:rms-rulindo'
    },
    '1099': {
      'warehouseCode': '1099',
      'name': 'RMS Rusizi',
      '_id': 'country:rw:zone:west:name:rms-rusizi'
    },
    '1093': {
      'warehouseCode': '1093',
      'name': 'RMS Rutsiro',
      '_id': 'country:rw:zone:west:name:rms-rutsiro'
    },
    '1078': {
      'warehouseCode': '1078',
      'name': 'RMS Rwamagana',
      '_id': 'country:rw:zone:east:name:rms-rwamagana'
    }
  },
  'LAFIYA': {
    'EHA-NATIONAL-WAREHOUSE': {
      warehouseCode: 'EHA-NATIONAL-WAREHOUSE',
      name: 'EHA National Warehouse',
      _id: 'zone:north-west:name:eha-national-warehouse'
    },
    'LAFIYA-KANO-STATE-WAREHOUSE': {
      warehouseCode: 'LAFIYA-KANO-STATE-WAREHOUSE',
      name: 'Lafiya Kano State Warehouse',
      _id: 'zone:north-west:name:lafiya-kano-state-warehouse'
    },
    'LAFIYA-JIGAWA-STATE-WAREHOUSE': {
      warehouseCode: 'LAFIYA-JIGAWA-STATE-WAREHOUSE',
      name: 'Lafiya Jigawa State Warehouse',
      _id: 'zone:north-west:name:lafiya-jigawa-state-warehouse'
    },
    'LAFIYA-SOKOTO-STATE-WAREHOUSE': {
      warehouseCode: 'LAFIYA-SOKOTO-STATE-WAREHOUSE',
      name: 'Lafiya Sokoto State Warehouse',
      _id: 'zone:north-west:name:lafiya-sokoto-state-warehouse'
    },
    'LAFIYA-KEBBI-STATE-WAREHOUSE': {
      warehouseCode: 'LAFIYA-KEBBI-STATE-WAREHOUSE',
      name: 'Lafiya Kebbi State Warehouse',
      _id: 'zone:north-west:name:lafiya-kebbi-state-warehouse'
    },
    'LAFIYA-BAUCHI-STATE-WAREHOUSE': {
      warehouseCode: 'LAFIYA-BAUCHI-STATE-WAREHOUSE',
      name: 'Lafiya Bauchi State Warehouse',
      _id: 'zone:north-east:name:lafiya-bauchi-state-warehouse'
    },
    'LAFIYA-CROSS-RIVER-STATE-WAREHOUSE': {
      warehouseCode: 'LAFIYA-CROSS-RIVER-STATE-WAREHOUSE',
      name: 'Lafiya Cross-River State Warehouse',
      _id: 'zone:south-south:name:lafiya-cross-river-state-warehouse'
    }
  },
  'shelflife': {
    'LAGOS_DC': {
      _id: 'country:ng:state:lagos:sdp:mebs-facility-lagos'
    }
  }
}
exports.WAREHOUSE_DEFINITIONS = WAREHOUSE_DEFINITIONS

// expects `DC-303 :: Axios Warehouse Awka`, `funder:pepfar`
exports.warehouseCodeToVirtualId = warehouseCodeToVirtualId
function warehouseCodeToVirtualId ({ warehouseCode, funderId, programId = undefined, useFunderSuffixForWarehouse = true, tenant = 'PSM' }) {
  if (!warehouseCode ||
    (programId && !programId.startsWith('program:')) ||
    (funderId && !funderId.startsWith('funder:'))
  ) {
    throw new Error(
      `Error usage: expects ({warehouseCode, funderId, programId}), e.g.
      warehouseCodeToVirtualId({
        warehouseCode: 'DC-303 :: Axios Warehouse Awka',
        programId: 'program:hiv-aids',
        funderId: 'funder:pepfar'
      })`
    )
  }

  if (!WAREHOUSE_DEFINITIONS[tenant]) {
    throw new Error(`Only PSM and EPN tenants allowed`)
  }

  const { _id } = warehouseCodeToVirtualProps(warehouseCode, tenant)

  return getFunderWarehouseId({
    locationId: _id,
    programId,
    funderId,
    useFunderSuffixForWarehouse
  })
}

/* Warehouse Ids to Warehouse Code
* @param {Object} api - API object
* @param {Array} warehouseIds - Array of warehouse codes
* @returns {Array} - Array of warehouse codes
*/
exports.warehouseIdToCode = warehouseIdToCode
async function warehouseIdToCode (api, warehouseIds) {
  const validWarehouseIds = warehouseIds && warehouseIds.filter(Boolean)

  if (!validWarehouseIds || validWarehouseIds.length === 0) {
    throw new Error(
      `Error usage: expects (warehouseIds), e.g.
      warehouseIdToCode(['zone:south-west:name:lagos'])`
    )
  }

  const locations = await api.location.getByIds(warehouseIds)
  const locationsByWarehouseCode = keyBy(locations, 'additionalData.warehouseCode')

  return Object.keys(locationsByWarehouseCode)
}

exports.getFunderWarehouseId = getFunderWarehouseId
/**
 * @param {Object} param
 * @param {string} param.locationId
 * @param {string} param.programId
 * @param {string} param.funderId
 * @param {boolean} param.useFunderSuffixForWarehouse
 * @returns {string}
 */
function getFunderWarehouseId ({locationId, programId, funderId, useFunderSuffixForWarehouse = true}) {
  // HIV program does not separate stock by funder (just commmits, the so-called "bulk allocation")
  // The EPN program currently have one funder assigned to them i.e
  // Warehouse locations currently created for the program (as at 2025-03-21) don't have an idea of virtual
  // funders since as its just single funder
  if (programId && ['program:hiv-aids', 'program:ke-epn', 'program:ng-epn', 'program:rwanda-rms', 'program:kano-essential-medicines'].includes(programId)) {
    return locationId
  }

  const shortFunderId = funderId.replace('funder:', '')
  const funderIdSuffix = shortFunderId && useFunderSuffixForWarehouse ? `-${shortFunderId}` : ''
  return `${locationId}${funderIdSuffix}`
}

// These are some of our hard-coded PSM supply warehouse codes:
// https://github.com/fielded/van-orga/issues/2702
// DC-301 :: MDS Abuja
// DC-303 :: Axios Warehouse Awka
// DC-309 :: MDS Warehouse Calabar
// DC-305 :: Axios Warehouse Gombe
// DC-306 :: Axios Warehouse Sokoto
// NDC-201 :: Abuja Premier Medical Warehouse
// NDC-202 :: Lagos Premier Medical Warehouse

// HEADS UP: these warehouses really don't correspond to Nigeria's geopolitical zones
// calabar for example is in south-south but supplies some south-east states
// that's what relationshipRules are used for.
exports.warehouseCodeToVirtualProps = warehouseCodeToVirtualProps
function warehouseCodeToVirtualProps (warehouseCode, tenant = 'PSM', lookupMap = WAREHOUSE_DEFINITIONS) {
  if (!lookupMap[tenant][warehouseCode]) {
    throw new Error(`Usage error: warehouseCode ${warehouseCode} not found in hard-coded list`)
  }
  return lookupMap[tenant][warehouseCode]
}

// Find a warehouse definition by its location `_id` for a tenant. Returns the
// matching definition, or `null` when no hard-coded warehouse matches. Unlike
// `resolveWarehouseByLocationId`, a missing definition is not an error here, so
// callers can branch on it explicitly instead of catching a throw.
/**
 * @param {string} locationId - The location ID to resolve the warehouse for
 * @param {string} tenant - The tenant to resolve the warehouse for
 * @returns {Object|null} - The warehouse definition, or null if none matches
 */
exports.findWarehouseByLocationId = findWarehouseByLocationId
function findWarehouseByLocationId (locationId, tenant) {
  const tenantsToSearch = tenant != null
    ? [tenant.toUpperCase()]
    : Object.keys(WAREHOUSE_DEFINITIONS)

  for (const tenantKey of tenantsToSearch) {
    const tenantDefinitions = WAREHOUSE_DEFINITIONS[tenantKey] || {}
    const match = Object.values(tenantDefinitions).find(
      w => w && (w._id === locationId || locationId.startsWith(`${w._id}-`))
    )
    if (match) {
      return match
    }
  }

  return null
}

// Resolve a warehouse definition by its location `_id` for a tenant
/**
 * @param {string} locationId - The location ID to resolve the warehouse for
 * @param {string} tenant - The tenant to resolve the warehouse for
 * @returns {Object} - The warehouse definition
 */
exports.resolveWarehouseByLocationId = resolveWarehouseByLocationId
function resolveWarehouseByLocationId (locationId, tenant) {
  const match = findWarehouseByLocationId(locationId, tenant)
  if (!match) {
    throw new Error(`Warehouse for locationId ${locationId} not found`)
  }
  return match
}
